/**
 * Custom TipTap TableHeader extension for QBR tables.
 *
 * Renders read-only headers with icon support, plus handles
 * injected QBR-specific headers (owner names, calculated columns).
 */
import { TableHeader } from "@tiptap/extension-table";
import { renderIconInCell } from "components/TipTapEditorPlugins/firstColumnIcon";
import styles from "./QBRTable.module.css";

export const QBRTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-qbr-score-header": { default: null },
      "data-qbr-rationale-header": { default: null },
      "data-qbr-owner-header": { default: null },
      "data-qbr-calc-header": { default: null }
    };
  },

  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const dom = document.createElement("th");
      Object.entries(HTMLAttributes).forEach(([key, value]) => {
        if (value != null) dom.setAttribute(key, value as string);
      });
      dom.contentEditable = "false";
      dom.classList.add(styles.qbrHeaderCell);

      // Injected headers: center-align owner/calc columns
      const isOwnerHeader = HTMLAttributes["data-qbr-owner-header"] != null;
      const isCalcHeader = HTMLAttributes["data-qbr-calc-header"] != null;
      const isScoreHeader = HTMLAttributes["data-qbr-score-header"] != null;
      const isRationaleHeader =
        HTMLAttributes["data-qbr-rationale-header"] != null;

      if (isOwnerHeader || isCalcHeader || isScoreHeader) {
        dom.classList.add(styles.qbrHeaderCellCenter);
      }

      if (
        isOwnerHeader ||
        isCalcHeader ||
        isScoreHeader ||
        isRationaleHeader
      ) {
        // These headers just show their text content
        const text = node.textContent || "";
        if (isOwnerHeader) {
          const span = document.createElement("span");
          span.className = styles.ownerHeaderName;
          span.textContent = text;
          dom.appendChild(span);
        } else {
          dom.textContent = text;
        }
        return { dom };
      }

      // Default: try icon rendering, fall back to content
      if (renderIconInCell(dom, node.textContent, true)) {
        return { dom };
      }

      const contentDOM = document.createElement("div");
      dom.appendChild(contentDOM);
      return { dom, contentDOM };
    };
  }
});
